import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

import { UsuarioService } from './usuarios.service';
import { Usuario } from './../usuario/usuario';

@Component({
  selector: 'app-resetar-senha',
  templateUrl: './resetar-senha.component.html',
  styleUrls: ['./usuarios.component.css'],
  providers: [UsuarioService]
})
export class ResetarSenhaComponent implements OnInit {
  public titulo: string = "Resetar Senha";
  public credencial:any =  {password: '', password_confirm:'', remember_token:''};
  public usuario: Usuario;
  constructor(private usuarioService: UsuarioService, private router: Router, private route: ActivatedRoute) {

  }

  carregarRememberToken(): void{
    this.route.queryParams.forEach((params: Params) => {
      let remembertoken = params['t'];
      this.credencial.remember_token = remembertoken;
    });
  }

  resetarSenha(): void{
    this.usuarioService.resetarSenha(this.credencial).then(() => this.irParaTelaLogin());
  }

  irParaTelaLogin(): void {
     this.router.navigate(['/aluno/login']);
  }

  ngOnInit() {
    this.carregarRememberToken();
  }

}



// WEBPACK FOOTER //
// ./src/app/usuarios/resetar-senha.component.ts